import { analytics } from '../firebase';
import { logDetailedEvent } from './firebaseService'; // Import for detailed logging
import { logEvent as firebaseLogEvent } from 'firebase/analytics';

/**
 * Logs a custom event to Firebase Analytics.
 * @param {string} eventName - The name of the event.
 * @param {object} [eventParams] - An object containing parameters for the event.
 */
export const trackEvent = (eventName, eventParams) => {
  if (!analytics) {
    console.warn('Firebase Analytics is not initialized.');
    return;
  }
  try {
    firebaseLogEvent(analytics, eventName, eventParams);
    console.log(`Analytics event logged: ${eventName}`, eventParams || '');
  } catch (error) {
    console.error('Error logging analytics event:', eventName, error);
  }
};

// Example of specific event tracking functions (can be expanded)

export const trackPageView = (pageTitle, pagePath, restaurantId = null) => {
  const validPageTitle = typeof pageTitle === 'string' && pageTitle.trim() !== '' ? pageTitle : (pagePath || 'Unknown Page');
  const validPagePath = typeof pagePath === 'string' && pagePath.trim() !== '' ? pagePath : '/'; // Default to '/' if undefined or empty

  // Log to Firebase Analytics (existing)
  trackEvent('page_view', {
    page_title: validPageTitle, // Use validated page title
    page_path: validPagePath, // Use validated page path
  });

  // Log to custom Firestore collection for detailed reporting
  // restaurantId can be null for general pages
  logDetailedEvent(restaurantId, 'page_view', { page_title: validPageTitle, page_path: validPagePath, restaurant_id: restaurantId }); // Use validated page title and path
};


export const trackPlaceOrder = (orderDetails) => {
  // Log to Firebase Analytics (existing)
  trackEvent('place_order', {
    restaurant_id: orderDetails.restaurantId,
    total_amount: orderDetails.totalAmount,
    item_count: orderDetails.items.length,
    customer_name: orderDetails.customerName, // Added for more context
    table_number: orderDetails.tableNumber, // Added for table booking context
  });

  // Log to custom Firestore collection for detailed reporting
  if (orderDetails.restaurantId) {
    logDetailedEvent(orderDetails.restaurantId, 'place_order', orderDetails);
  } else {
    console.warn('trackPlaceOrder: restaurantId not provided, detailed event not logged.');
  }
};


export const trackAddToCart = (itemDetails, restaurantId) => {
  // Log to Firebase Analytics (existing)
  trackEvent('add_to_cart', {
    item_id: itemDetails.id,
    item_name: itemDetails.name,
    item_category: itemDetails.category,
    price: itemDetails.offerPrice && itemDetails.offerPrice < itemDetails.price ? itemDetails.offerPrice : itemDetails.price,
    quantity: itemDetails.qty || 1, // Default to 1 if quantity not specified at this point
  });

  // Log to custom Firestore collection for detailed reporting
  if (restaurantId) {
    logDetailedEvent(restaurantId, 'add_to_cart', { ...itemDetails, restaurant_id: restaurantId });
  } else {
    console.warn('trackAddToCart: restaurantId not provided, detailed event not logged.');
  }
};


export const trackAdminAction = (actionName, details) => {
  // Log to Firebase Analytics (existing)
  trackEvent(`admin_${actionName}`, details);

  // Log to custom Firestore collection for detailed reporting
  const restaurantId = details && details.restaurantId ? details.restaurantId : null;
  if (restaurantId) {
    logDetailedEvent(restaurantId, `admin_${actionName}`, details);
  } else {
    // Log even if no restaurantId, but with null for restaurantId field
    logDetailedEvent(null, `admin_${actionName}`, details);
    console.warn(`trackAdminAction (${actionName}): restaurantId not available in details, logged with null restaurantId.`);
  }
};